//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.BaseSubObjectBuilder.js";
let d=[[[0,"Format",0,0],[0,"String",0,0]],[[["objTags","attrTitles","format"],"SetFormatValue",{},3,0],[["objTags","parentTags","attrTitles","format"],"SetFormatValue1",{},4,0],[["objTags","attrTitles","appendFormat"],"AppendFormat",{},3,0],[[],"ClearFormat",{},0,0],[["nObjs","objTags"],"GetReferencedAttributes",{R_:{attrTitles:""}},0,0]],[]];
SPLM.Diagramming.FormattedStringBuilder = class extends SPLM.Diagramming.BaseSubObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.FormattedStringBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;